// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__7YasK","loaderSvg":"Loader_loaderSvg__2wLSm"};